import { safeDiv, costDiv, formatCurrency, formatNumber, formatMultiplier, formatPercent } from './formatters'
import type { CalculatorResult } from '../types'

const FLOAT_EPSILON = 1e-9

function floorToInt(value: number) {
  return Math.floor(value + FLOAT_EPSILON)
}

export interface MetricasComerciaisInputs {
  investimento: number
  cpm: number
  ctr: number
  taxaCliqueLead: number
  taxaLeadAgendamento: number
  taxaAgendadaRealizada: number
  taxaConsultaVenda: number
  ticketMedio: number
}

export function calcularMetricasComerciais(inputs: MetricasComerciaisInputs): CalculatorResult[] {
  const {
    investimento, cpm, ctr, taxaCliqueLead,
    taxaLeadAgendamento, taxaAgendadaRealizada, taxaConsultaVenda, ticketMedio,
  } = inputs

  const impressoes = cpm > 0 ? floorToInt((investimento / cpm) * 1000) : 0
  const cliques = floorToInt(impressoes * (ctr / 100))
  const cpc = costDiv(investimento, cliques)

  const leads = floorToInt(cliques * (taxaCliqueLead / 100))
  const cpl = costDiv(investimento, leads)
  const agendados = floorToInt(leads * (taxaLeadAgendamento / 100))
  const presentes = floorToInt(agendados * (taxaAgendadaRealizada / 100))
  const vendas = floorToInt(presentes * (taxaConsultaVenda / 100))
  const faturamento = vendas * ticketMedio
  const cac = costDiv(investimento, vendas)
  const roas = safeDiv(faturamento, investimento)
  const taxaLeadVenda = leads > 0 ? (vendas / leads) * 100 : 0

  return [
    { label: 'Impressões', value: impressoes, formattedValue: formatNumber(impressoes) },
    { label: 'Cliques', value: cliques, formattedValue: formatNumber(cliques) },
    { label: 'CPC', value: cpc, formattedValue: formatCurrency(cpc) },
    { label: 'Leads', value: leads, formattedValue: formatNumber(leads) },
    { label: 'CPL', value: cpl, formattedValue: formatCurrency(cpl) },
    { label: 'Agendamentos', value: agendados, formattedValue: formatNumber(agendados) },
    { label: 'Consultas Realizadas', value: presentes, formattedValue: formatNumber(presentes) },
    { label: 'Vendas', value: vendas, formattedValue: formatNumber(vendas) },
    { label: 'Faturamento', value: faturamento, formattedValue: formatCurrency(faturamento), status: faturamento > investimento ? 'success' : 'danger' },
    { label: 'CAC/CPA', value: cac, formattedValue: formatCurrency(cac) },
    { label: 'ROAS', value: roas, formattedValue: formatMultiplier(roas), status: roas >= 3 ? 'success' : roas >= 1.5 ? 'warning' : 'danger' },
    { label: 'Taxa Lead → Venda', value: taxaLeadVenda, formattedValue: formatPercent(taxaLeadVenda) },
  ]
}
